import { createContext, useContext } from 'react';

/**
 * What the canvas can ask the page to do. Nodes and edges call these instead
 * of firing window events, so the canvas has no hidden channel to the page and
 * a second canvas (the run view) simply provides none.
 *
 *   onAddAfter(fromId, port)        a "+" under a node's open branch
 *   onInsertOnEdge({from, to, port}) the "+" on an edge: a step between two
 *   onRemoveEdge({from, to, port})   the "x" on a selected edge
 *   onRunTrigger(nodeId)             the run button on a manual trigger
 */
const noop = () => {};

export const CanvasActionsContext = createContext({
  onAddAfter: noop,
  onInsertOnEdge: noop,
  onRemoveEdge: noop,
  onRunTrigger: noop,
});

export const useCanvasActions = () => useContext(CanvasActionsContext);
